<template>
  <div class="logradius-datatable">
    <v-data-table
      dense
      :headers="headers"
      :items="logsradius.data"
      :server-items-length="logsradius.total"
      :items-per-page="100"
      :loading="isLoading"
      :options.sync="parentOptions"
      :footer-props="{
        itemsPerPageOptions: [10, 50, 100, -1],
      }"
      no-data-text="Pas de logradius"
    >
      <template v-slot:item.created_at="{ item }">
        {{ getInternationalDate(item.created_at) }}
      </template>
      <template v-slot:item.account_status_type="{ item }">
        {{ item.account_status_type }}
      </template>
      <template v-slot:item.reply_packet_type="{ item }">
        <div
          v-if="item.reply_packet_type == 'Access-Accept'"
          style="color: rgb(102, 102, 255); font-weight: bold"
        >
          {{ item.reply_packet_type }}
        </div>
        <div
          v-else-if="item.reply_packet_type == 'Access-Reject'"
          style="color: rgb(255, 102, 153); font-weight: bold"
        >
          {{ item.reply_packet_type }}
        </div>
        <div v-else>
          {{ item.reply_packet_type }}
        </div>
      </template>

      <template v-slot:item.account_terminate_cause="{ item }">
        <div
          v-if="item.account_terminate_cause == 'User-Error'"
          style="color: rgb(239, 41, 41); font-weight: bold"
        >
          {{ item.account_terminate_cause }}
        </div>
        <div
          v-else-if="item.account_terminate_cause == 'Lost-Carrier'"
          style="color: rgb(252, 175, 62); font-weight: bold"
        >
          {{ item.account_terminate_cause }}
        </div>
        <div
          v-else-if="item.account_terminate_cause == 'Session-Timeout'"
          style="color: rgb(206, 225, 75); font-weight: bold"
        >
          {{ item.account_terminate_cause }}
        </div>
        <div
          v-else-if="item.account_terminate_cause == 'User-Request'"
          style="color: rgb(114, 159, 207); font-weight: bold"
        >
          {{ item.account_terminate_cause }}
        </div>
        <div v-else>
          {{ item.account_terminate_cause }}
        </div>
      </template>

      <template v-slot:item.account_status_type="{ item }">
        <div
          v-if="item.account_status_type == 'Start'"
          style="color: rgb(102, 204, 51); font-weight: bold"
        >
          {{ item.account_status_type }}
        </div>
        <div
          v-else-if="item.account_status_type == 'Stop'"
          style="color: rgb(204, 51, 102); font-weight: bold"
        >
          {{ item.account_status_type }}
        </div>
        <div
          v-else-if="item.account_status_type == 'Interim-Update'"
          style="color: rgb(225, 204, 51); font-weight: bold"
        >
          {{ item.account_status_type }}
        </div>
        <div
          v-else-if="item.account_status_type == 'Accounting-On'"
          style="color: rgb(157, 176, 41); font-weight: bold"
        >
          {{ item.account_status_type }}
        </div>
        <div
          v-else-if="item.account_status_type == 'Accounting-Off'"
          style="color: rgb(245, 121, 0); font-weight: bold"
        >
          {{ item.account_status_type }}
        </div>
        <div v-else>
          {{ item.account_status_type }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { date } from "@/composables/date";
import { computed } from "@vue/composition-api";

export default {
  props: {
    logsradius: Object,
    firstLoad: Boolean,
    isLoading: Boolean,
    options: Object,
  },

  setup(props, { emit }) {
    const parentOptions = computed({
      get: () => props.options,
      set: (value) => {
        emit("update:options", value);
      },
    });
    const { getInternationalDate } = date();

    return {
      getInternationalDate,
      parentOptions,
      headers: [
        { text: "Date", value: "created_at" },
        { text: "Type Radius", value: "operation" },
        { text: "Réponse", value: "reply_packet_type" },
        { text: "Cause Acct Fin", value: "account_terminate_cause" },
        { text: "Acct Status", value: "account_status_type" },
        { text: "IP", value: "client_ip_address" },
        { text: "NAS", value: "nas_identifier" },
        { text: "Login", value: "username" },
        { text: "Password", value: "user_password" },
        { text: "Origine", value: "origin" },
        { text: "AcctSessionId", value: "account_session_id" },
        { text: "AcctDelay Time", value: "account_delay_time" },
        { text: "AcctSession Time", value: "account_session_time" },

        { text: "AccountOutputOctets", value: "account_output_packets" },
        { text: "AccountInputOctets", value: "account_input_packets" },
        { text: "ID Appelant", value: "calling_station_id" },
        { text: "ID Appelé", value: "called_station_id" },
        { text: "Serveur", value: "server" },
        { text: "IDLog", value: "id" },
        { text: "Frame IP Address", value: "frame_ip" },
      ],
    };
  },
};
</script>
<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
